import { render, staticRenderFns } from "./SntBreadcrumb.vue?vue&type=template&id=2af8c20c&scoped=true&"
import script from "./SntBreadcrumb.vue?vue&type=script&lang=js&"
export * from "./SntBreadcrumb.vue?vue&type=script&lang=js&"
import style0 from "./SntBreadcrumb.vue?vue&type=style&index=0&id=2af8c20c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2af8c20c",
  null
  
)

export default component.exports